<admin-app-header></admin-app-header>

<div class="container-fluid transparency-page">
    <div class="page-header">
        <h1><i class="fa-solid fa-eye me-2"></i>Transparency Report</h1>
        <p class="text-muted">Known limitations, potential oversights, and integration gaps across the platform. This page helps the team stay aligned on what the code does and doesn't handle.</p>
    </div>

    <div class="legend mb-4">
        <span class="me-3"><span class="badge bg-danger">Risk</span> Could cause real problems if not addressed</span>
        <span class="me-3"><span class="badge bg-warning text-dark">Warning</span> Known gap that may need attention</span>
        <span class="me-3"><span class="badge bg-info text-dark">Info</span> By design or low impact</span>
        <span class="mx-3">|</span>
        <span class="me-3"><span class="badge bg-success">Mitigated</span> Workaround or fix in place</span>
        <span class="me-3"><span class="badge bg-warning text-dark">Known</span> Acknowledged, no fix yet</span>
        <span class="me-3"><span class="badge bg-danger">To Do</span> Needs to be fixed</span>
        <span class="mx-3">|</span>
        <span class="me-3"><span class="badge bg-success">Aligned</span> Matches the agreement</span>
        <span class="me-3"><span class="badge bg-primary">Needs sign-off</span> Our assumption, please confirm</span>
    </div>

    <div *ngFor="let section of sections" class="section-block">
        <h3 class="section-title">
            <i [class]="section.icon + ' me-2'"></i>{{ section.name }}
        </h3>
        <p *ngIf="section.intro" class="text-muted">{{ section.intro }}</p>
        <p *ngIf="section.link" class="text-muted">
            See also the <a [routerLink]="[section.link.route]">{{ section.link.label }}</a>.
        </p>

        <div *ngFor="let item of section.items" class="item-card">
            <div class="item-card__header">
                <h5 class="item-card__title">{{ item.title }}</h5>
                <div class="d-flex gap-2">
                    <span [class]="getSeverityClass(item.severity)">{{ item.severity }}</span>
                    <span [class]="getStatusClass(item.status)">{{ item.status === 'confirm' ? 'needs sign-off' : item.status }}</span>
                </div>
            </div>
            <div class="item-card__body">
                <div class="item-row agreement" *ngIf="item.agreement">
                    <strong>Fee Share Agreement says:</strong>
                    <p><em>{{ item.agreement }}</em></p>
                </div>
                <div class="item-row">
                    <strong>{{ item.agreement || item.status === 'confirm' || item.status === 'aligned' ? 'What the system does:' : 'What happens:' }}</strong>
                    <p>{{ item.description }}</p>
                </div>
                <div class="item-row">
                    <strong>Impact:</strong>
                    <p>{{ item.impact }}</p>
                </div>
                <div class="item-row" *ngIf="item.recommendation">
                    <strong>{{ item.status === 'confirm' ? 'Decision needed:' : 'Recommendation:' }}</strong>
                    <p>{{ item.recommendation }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
